import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertDocumentInternalAuditResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertDocumentInternalAuditResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type InsertDocumentInternalAuditResultInput = {
  InternalAuditReportId: string;
  DocumentIds: string[];
  // COI-650: V2 required Rating on this insert; the form schema has always
  // made it mandatory, so the type now matches.
  Rating: number;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertDocumentInternalAuditResult = createMutationHook({
  name: 'insertDocumentInternalAuditResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.internalAuditResult.insertDocument.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: InsertDocumentInternalAuditResultInput) => input,
  mapResponse: (result: {
    Ids: string[];
  }): InsertDocumentInternalAuditResultMutation => ({
    insertChildDocumentInternalAuditResult: {
      __typename: 'InsertChildDocumentAssessmentResultOutput',
      Ids: result.Ids,
    },
  }),
  invalidate: (trpc) => [
    trpc.frontend.internalAuditResult.pathKey(),
    trpc.frontend.assessment.internalAuditResultCount.queryKey(),
    // COI-471 parity: Apollo twin also evicts `internal_audit_report`.
    trpc.frontend.internalAuditReport.pathKey(),
  ],
  graphqlDocument: InsertDocumentInternalAuditResultDocument,
  graphqlVariables: (input: InsertDocumentInternalAuditResultInput) => ({
    ...input,
  }),
  evictFields: [
    'document_internal_audit_result',
    'internal_audit_report',
    'document_internal_audit_result_aggregate',
  ],
});
